import { Control, Controller } from "react-hook-form";
import { IOrganizationDetails } from "../../core/api/organizations/types";
import { TwoColGrid } from "../../components/Layout/Layout";
import Checkbox from "../../ui-lib/components/Checkbox/Checkbox";
import useTranslations from "../../core/i18n/useTranslations";

export const BlockUserCostCenterRow = ({
  control,
}: {
  control: Control<IOrganizationDetails, any, IOrganizationDetails>;
}) => {
  const t = useTranslations();
  return (
    <TwoColGrid>
      <Controller
        name="blockUserPages"
        control={control}
        render={({ field }) => (
          <Checkbox
            label={t("Organizations:block_user_pages")}
            checked={!!field.value}
            onChange={field.onChange}
          />
        )}
      />
      <Controller
        name="requireCostCenter"
        control={control}
        render={({ field }) => (
          <Checkbox
            label={t("Organizations:require_cost_center")}
            checked={!!field.value}
            onChange={field.onChange}
          />
        )}
      />
    </TwoColGrid>
  );
};
